import { useCallback } from 'react';
import useHttp from './useHttp';
import { useAuth } from '../context/authContext';

// Encapsulates all /welcome dashboard API calls: the widget manifest (which
// widgets the user may see + their saved layout), per-widget data (served from
// the shared statistic cache on the backend), and layout persistence.
export default function useDashboard() {
  const { sendRequest } = useHttp();
  const { getAuthHeaders } = useAuth();

  const getManifest = useCallback(async () => {
    return sendRequest({
      url: '/api/v1/dashboard/manifest',
      method: 'GET',
      headers: getAuthHeaders(),
    });
  }, [getAuthHeaders, sendRequest]);

  const getWidgetData = useCallback(
    async (widgetId, { forceRecompute = false } = {}) => {
      return sendRequest({
        url: `/api/v1/dashboard/widgets/${encodeURIComponent(widgetId)}`,
        method: 'GET',
        headers: getAuthHeaders(),
        params: forceRecompute ? { forceRecompute: 'true' } : undefined,
      });
    },
    [getAuthHeaders, sendRequest]
  );

  const saveLayout = useCallback(
    async ({ order, hidden }) => {
      return sendRequest({
        url: '/api/v1/dashboard/layout',
        method: 'PUT',
        headers: getAuthHeaders(),
        body: { order, hidden },
      });
    },
    [getAuthHeaders, sendRequest]
  );

  return { getManifest, getWidgetData, saveLayout };
}
